import { render, staticRenderFns } from "./Carnet.vue?vue&type=template&id=08fc8e5b&"
import script from "./Carnet.vue?vue&type=script&lang=js&"
export * from "./Carnet.vue?vue&type=script&lang=js&"
import style0 from "./Carnet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports